import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { AdviserConfiguration } from '../../Models/Models/Adviser/Configuration/AdviserConfiguration';

declare var IS_RUNNING_IN_APP_POOL;

export class SubmitAdviserConfigurationInstructionClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public post(instructionId: number): Promise<AdviserConfiguration, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Adviser/SubmitAdviserConfigurationInstruction/Post';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { instructionId: instructionId }

    return AjaxWrapper.post<AdviserConfiguration, any>(url, data);
  }
}

